import React from "react";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack/v-stack";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import * as styles from "./partners-integration.css";

interface StepConfig {
    periodKey: string;
    titleKey: string;
    bulletKeys: string[];
}

const STEPS: StepConfig[] = [
    {
        periodKey: gettextNoop("partners.integration.step_1_period"),
        titleKey: gettextNoop("partners.integration.step_1_title"),
        bulletKeys: [gettextNoop("partners.integration.step_1_body")],
    },
    {
        periodKey: gettextNoop("partners.integration.step_2_period"),
        titleKey: gettextNoop("partners.nav.integration"),
        bulletKeys: [
            gettextNoop("partners.integration.step_2_body_1"),
            gettextNoop("partners.integration.step_2_body_2"),
            gettextNoop("partners.integration.step_2_body_3"),
        ],
    },
    {
        periodKey: gettextNoop("partners.integration.step_3_period"),
        titleKey: gettextNoop("partners.integration.step_3_title"),
        bulletKeys: [gettextNoop("partners.integration.step_3_body")],
    },
];

export default function PartnersIntegration(): JSX.Element {
    const sectionRef = useSectionImpression("integration", 5);

    return (
        <section ref={sectionRef} id="integration" className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <VStack spacing="xs">
                        <Text textStyle="caption-s" color="secondary" className={styles.eyebrow}>
                            {gettext("partners.nav.integration")}
                        </Text>
                        <Heading textStyle="hero-l" as="h2">
                            {gettext("partners.integration.headline")}
                        </Heading>
                    </VStack>
                </div>

                <div className={styles.steps}>
                    {STEPS.map(({ periodKey, titleKey, bulletKeys }) => (
                        <VStack key={periodKey} spacing="sm">
                            <div className={styles.stepPeriod}>
                                <Text
                                    textStyle="caption-s"
                                    color="secondary"
                                    className={styles.eyebrow}
                                >
                                    {gettext(periodKey)}
                                </Text>
                            </div>
                            <VStack spacing="md">
                                <Heading textStyle="hero-xs" as="h3">
                                    {gettext(titleKey)}
                                </Heading>
                                <ul className={styles.bulletList}>
                                    {bulletKeys.map((key) => (
                                        <li key={key} className={styles.bulletItem}>
                                            <Text textStyle="body" color="secondary">
                                                {"·"}
                                            </Text>
                                            <Text textStyle="body" color="secondary">
                                                {gettext(key)}
                                            </Text>
                                        </li>
                                    ))}
                                </ul>
                            </VStack>
                        </VStack>
                    ))}
                </div>
            </div>
        </section>
    );
}
